const canUseSendBeacon = ({
  headers,
  enableSendBeacon
}) => !!window && // window.navigator.sendBeacon &&
!(!!headers && Object.keys(headers).length > 0) && enableSendBeacon && !!window.Blob;

const sendBeacon = ({
  win,
  url,
  data,
  useBlob = true
}) => {
  try {
    const json = JSON.stringify(data);

    if (!win.navigator.sendBeacon) {
      throw new Error(`No sendBeacon available`);
    }

    if (useBlob) {
      const blob = new Blob([json], {
        type: 'application/json'
      });
      return win.navigator.sendBeacon(url, blob);
    }

    return win.navigator.sendBeacon(url, json);
  } catch (e) {
    return false;
  }
};
/*
const parseJSON = (response: Response) => {
  if (!response.status.toString().startsWith('2')) {
    console.error(
      `ERROR: An unexpected status code (${response.status}) was received when posting the log messages to the logging service...`,
    );
    console.error(JSON.stringify(response));
  }
};

const postLogData = ({ url, data }: SendBeaconOptions) => {
  const json = JSON.stringify(data);
  fetch(url, {
    method: 'POST',
    mode: 'cors',
    keepalive: true,
    headers: new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }),
    body: json,
  })
    .then((response) => {
      parseJSON(response);
    })
    .catch((error) => {
      console.error(
        'ERROR: An error occurred posting the log messages to the logging service...',
      );
      console.error(JSON.stringify(error));
    });
};
*/


const extendIfDefined = (target, source) => {
  /* eslint-disable no-restricted-syntax */
  for (const key in source) {
    /* eslint-disable no-prototype-builtins */
    if (source.hasOwnProperty(key)) {
      target[key] = source[key];
    }
  }
};

const isBrowser = () => typeof window !== 'undefined' && window.location !== undefined; // eslint-disable-next-line no-unused-vars


const noop = (...args) => {// pass
};

const formatStringForPost = stack => stack && (stack === null || stack === void 0 ? void 0 : stack.split('\n').join('').split('    ').join(' ')) || null;

export { canUseSendBeacon, extendIfDefined, isBrowser, noop, sendBeacon, formatStringForPost }; // export { extendIfDefined, isBrowser, noop, postLogData };